module.exports = __webpack_public_path__ + "img/img4.cc9bf948.png";